import Sentiment from "sentiment";

const analyzer = new Sentiment();

export interface ScoredMsg {
  text: string;
  createdAt: number;
  score: number;             // scaled score (-5 to 5)
  userId: string;           // User ID
  userName: string;         // User's display name
}

// Helper function to scale score between -5 and 5 with 0.1 increments
function scaleScore(rawScore: number): number {
  // First normalize to -1 to 1 range
  const normalized = Math.max(-1, Math.min(1, rawScore / 5));
  // Then scale to -5 to 5 range with 0.1 precision
  return Math.round(normalized * 50) / 10;
}

export function score(text: string, ts: number, userId: string, userName: string): ScoredMsg {
  const { score } = analyzer.analyze(text);
  return { 
    text, 
    createdAt: ts, 
    score: scaleScore(score),
    userId,
    userName 
  };
}
